import { render, staticRenderFns } from "./ResultDialogQuestion.vue?vue&type=template&id=3c4283cc&"
import script from "./ResultDialogQuestion.vue?vue&type=script&lang=js&"
export * from "./ResultDialogQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports